import { Component, OnInit } from '@angular/core';

@Component({
    selector: '[aaColumnBar]',
    templateUrl: './column-bar.component.html',
    styleUrls: [
        './column-bar.component.scss'
    ],
    standalone: false
})
export class ColumnBarComponent implements OnInit
{
    constructor() { }

    ngOnInit ()
    {
    }
}
